"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../../Button");
var _Icon = require("../../Icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const csv = require('csvtojson');
function uploadIcon(uploadCode) {
  let iconName;
  switch (uploadCode) {
    case 'ideal':
      iconName = [['fa', 'cloud-upload-alt']];
      break;
    case 'aborted':
      iconName = [['fa', 'cloud'], ['fas', 'exclamation']];
      break;
    case 'success_valid':
    case 'success_invalid':
      iconName = [['fa', 'cloud'], ['fas', 'check']];
      break;
    case 'progress':
      iconName = [['fa', 'cloud'], ['fa', 'sync-alt']];
      break;
    default:
      iconName = [['fa', 'cloud-upload-alt']];
  }
  const IconList = iconName.map(iconType => /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: iconType,
    className: "uploader--icon uploader--icon-".concat(uploadCode)
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, IconList);
}
const InitialScreenNode = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Upload Files"), /*#__PURE__*/_react.default.createElement("p", null, "Drag and drop file(s) here."));
const ProgressScreenNode = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Upload Files"), /*#__PURE__*/_react.default.createElement("p", null, "File upload is in progress..."));
const CompleteScreenSuccessNode = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", null, "Upload completed."));
const FileUploader = _ref => {
  let {
    fileType = '',
    multiple = false,
    recordLimit,
    isUploader,
    uploadCallBack,
    initialScreenCopy = /*#__PURE__*/_react.default.createElement(InitialScreenNode, null),
    progressScreenCopy = /*#__PURE__*/_react.default.createElement(ProgressScreenNode, null),
    completeScreenSuccessCopy = /*#__PURE__*/_react.default.createElement(CompleteScreenSuccessNode, null),
    uploadButtonCopy = 'Upload file(s)',
    invalidFileTypeCopy = 'Sorry, this file type is not allowed.',
    overlay = false,
    csvParse = false,
    arrayFields,
    getJsonWithoutEmptyCells = false
  } = _ref;
  const [uploadStatus, SetUploadStatus] = (0, _react.useState)({
    uploadCode: 'ideal',
    errorMsg: '',
    isValidType: true
  });
  (0, _react.useEffect)(() => {
    SetUploadStatus({
      ...uploadStatus,
      uploadCode: 'ideal'
    });
  }, [isUploader]);

  // Callback function to be called from outside of component
  const notifyUpload = notficationCode => {
    if (notficationCode === 'success_valid' || notficationCode === 'success_invalid') {
      SetUploadStatus({
        ...uploadStatus,
        uploadCode: notficationCode
      });
    } else if (notficationCode === 'aborted') {
      SetUploadStatus({
        ...uploadStatus,
        uploadCode: notficationCode
      });
    }
  };

  // Initiate upload process by exposing external callback
  const uploadTrigger = acceptedFiles => {
    if (uploadCallBack && uploadStatus.isValidType) {
      SetUploadStatus({
        ...uploadStatus,
        uploadCode: 'progress'
      });
      uploadCallBack(acceptedFiles, notifyUpload);
    }
  };
  const prepareCSVtoJson = csvStr => {
    const jsonObject = [];
    const headerObject = {};
    arrayFields.forEach(value => {
      headerObject[value] = item => item === '' ? [] : item.split(',');
    });
    csv({
      flatKeys: false,
      checkType: true,
      trim: true,
      colParser: headerObject,
      ignoreEmpty: getJsonWithoutEmptyCells ? true : false
    }).fromString(csvStr).subscribe(csvObject => {
      jsonObject.push(csvObject);
    }).on('done', () => {
      uploadTrigger(jsonObject);
    });
  };

  // Function to return record count of all provided files (.CSV)
  const ValidRecords = acceptedFiles => {
    let recordExceed = false;
    let noRecord = false;
    let lines;
    const errorRecordExceeded = "Upload aborted : CSV file has more than ".concat(recordLimit, " ad units.");
    const errorNoRecord = 'Upload aborted : CSV file has 0 ad units.';
    const errorBoth = "Upload aborted : CSV file has more than ".concat(recordLimit, " or 0 ad units.");
    let errorMsg = '';
    let csvString = '';
    acceptedFiles.map((file, index) => {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        lines = reader.result.trim().split('\n').map(item => item.trim());
        csvString = reader.result;
      };
      reader.onloadend = () => {
        if (lines.length - 1 > recordLimit) {
          recordExceed = true;
          errorMsg = errorRecordExceeded;
        } else if (lines.length - 1 <= 0) {
          noRecord = true;
          errorMsg = errorNoRecord;
        }
        if (recordExceed && noRecord) {
          errorMsg = errorBoth;
        }
        if (index === acceptedFiles.length - 1) {
          SetUploadStatus({
            ...uploadStatus,
            uploadCode: recordExceed || noRecord ? 'aborted' : 'progress',
            errorMsg,
            isValidType: !(recordExceed || noRecord)
          });
          if (!(recordExceed || noRecord)) {
            prepareCSVtoJson(csvString);
          }
        }
      };
    });
  };

  // dropzone callback function , called everytime user drop / select files to upload
  const onDrop = (0, _react.useCallback)((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      SetUploadStatus({
        ...uploadStatus,
        uploadCode: 'aborted',
        errorMsg: "".concat(invalidFileTypeCopy),
        isValidType: false
      });
      return true;
    }

    // CSV file record count validation check
    if (fileType === 'text/csv, application/vnd.ms-excel' && csvParse && recordLimit) {
      ValidRecords(acceptedFiles);
    } else {
      uploadTrigger(acceptedFiles);
    }
  }, []);
  const {
    getRootProps,
    getInputProps,
    open
  } = (0, _reactDropzone.useDropzone)({
    accept: fileType,
    noClick: true,
    noKeyboard: true,
    multiple,
    onDrop
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "upload-container upload-container--".concat(uploadStatus.uploadCode)
  }, getRootProps()), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    "data-testid": "input"
  }, getInputProps())), /*#__PURE__*/_react.default.createElement("div", {
    className: "file-upload-wrap file-upload-wrap-".concat(uploadStatus.uploadCode)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-container icon-container--".concat(uploadStatus.uploadCode)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon__wrapper"
  }, uploadIcon(uploadStatus.uploadCode))), uploadStatus.uploadCode === 'progress' && progressScreenCopy, (uploadStatus.uploadCode === 'success_invalid' || uploadStatus.uploadCode === 'success_valid') && completeScreenSuccessCopy, (uploadStatus.uploadCode === 'ideal' || uploadStatus.uploadCode === 'aborted') && initialScreenCopy, (uploadStatus.uploadCode === 'ideal' || uploadStatus.uploadCode === 'aborted') && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    buttontext: uploadButtonCopy,
    onClick: open,
    icon: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fa', 'arrow-up'],
      size: "2x"
    }),
    className: "upload--button"
  }), uploadStatus.uploadCode === 'aborted' && /*#__PURE__*/_react.default.createElement("p", {
    className: "text-danger file--error",
    style: {
      textAlign: 'center'
    }
  }, uploadStatus.errorMsg), overlay && /*#__PURE__*/_react.default.createElement("div", {
    id: "overlay-file-upload",
    style: {
      display: uploadStatus.uploadCode === 'progress' ? 'block' : 'none'
    }
  })));
};
exports.FileUploader = FileUploader;
FileUploader.propTypes = {
  /** A valid case-insensitive filename extension, starting with a period (".") character.
   * For example: `.jpg`, `.pdf`, or `.doc`. A valid MIME type string, with no extensions.
   The string `audio/*` meaning "any audio file".
   The string `video/*` meaning "any video file".
   The string `image/*` meaning "any image file".
   The string `text/csv, application/vnd.ms-excel` meaning "any CSV file".
  */
  fileType: _propTypes.default.string,
  /** Specify if need to upload multiple files. */
  multiple: _propTypes.default.bool,
  /** Invoke callback method once file upload is started. */
  uploadCallBack: _propTypes.default.func,
  /** This is specific to CSV file type. We can limit number of rows in CSV. */
  recordLimit: _propTypes.default.number,
  /** First screen DOM content. We can override it with our own DOM structure. */
  initialScreenCopy: _propTypes.default.node,
  /** Upload in-progress screen DOM content. We can override it with our own DOM structure. */
  progressScreenCopy: _propTypes.default.node,
  /** Upload completed screen DOM content. We can override it with our own DOM structure. */
  completeScreenSuccessCopy: _propTypes.default.node,
  /** Modify upload button text. */
  uploadButtonCopy: _propTypes.default.string,
  /** Error message for invalid file type. */
  invalidFileTypeCopy: _propTypes.default.string,
  /** Block interaction on page if upload is in-progress. */
  overlay: _propTypes.default.bool,
  /** If we want to read the CSV file */
  csvParse: _propTypes.default.bool,
  /** List of header values which we want type Array. */
  arrayFields: _propTypes.default.arrayOf(_propTypes.default.string),
  /** After CSV parse, get JSON object without empty cells. If this is get to false, we will get full JSON object. */
  getJsonWithoutEmptyCells: _propTypes.default.bool,
  /** Dislays file uploader component if set to true. */
  isUploader: _propTypes.default.bool
};